import PreferredStoreAndZipCode from 'components/ShopYourStore/PreferredStoreAndZipCode/PreferredStoreAndZipCode';

export default PreferredStoreAndZipCode;
